import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink, {
  type Props as PlainButtonOrLinkProps,
} from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import stashPaddleStyles from './StashPaddles.scss';

export interface Props
  extends Omit<PlainButtonOrLinkProps, 'className' | 'type'> {
  className?: string;
  dataHook?: string;
}

export const StashPaddle: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className,
  onClick,
  dataHook,
  disabled,
  ...rest
}) => {
  return (
    <div
      className={classnames(
        stashPaddleStyles['duper'],
        className,
        !disabled && stashPaddleStyles['enabled']
      )}
      data-hook={dataHook}
    >
      <PlainButtonOrLink
        onClick={onClick}
        type="button"
        disabled={disabled}
        {...rest}
      >
        {children}
      </PlainButtonOrLink>
    </div>
  );
};
StashPaddle.displayName = 'StashPaddle';

export default StashPaddle;
